<mat-dialog-content>
  <!-- {{'maksut.vastaanotto-aloitettu-dialog.otsikko' | translate | async}} -->
  <lemon-dialog-header>
    <div>{{ 'maksut.miten-lasku-on-maksettu' | translate | async }}</div>
  </lemon-dialog-header>

  <form>
    <!-- {{'maksut.vastaanotto-aloitettu-dialog.teksti' | translate | async}} -->
    <div app-maksut-maksutapa [formField]="lomake.maksutapa" [filterNonActive]="true" [error]="lomake.maksutapa().errors().length > 0 && lomake.maksutapa().touched()"></div>
    @if (onkoVirhe(lomake.maksutapa, 'required') && lomake.maksutapa().touched()) {
      <mat-error>{{ 'maksut.valitse-maksutapa' | translate | async }}</mat-error>
    }
    <!-- <p style="margin: 3em 3em 2em 3em;">
    Yrityksellesi on nyt luotu verkkolaskuosoite ja laskujen vastaanotto on päällä.
    Ilmoita verkkolaskuosoite laskuttajillesi niin laskut saapuvat Lemonaidiin.
  </p> -->

    <!-- <pre>{{tositteenPvm?.errors | json}}</pre> -->
    <mat-form-field style="width: 230px; margin: 0 auto; display: block">
      <mat-label>{{ 'maksut.maksupaivamaara' | translate | async }}</mat-label>
      <input numberDatePicker matInput [formField]="lomake.tositteenPvm" [matDatepicker]="pickerDay" [min]="minDate" [max]="maxDate" autocomplete="1" data-lpignore="true" />
      <mat-datepicker-toggle matSuffix [for]="pickerDay"></mat-datepicker-toggle>
      <mat-datepicker #pickerDay></mat-datepicker>
    </mat-form-field>
    @if (lomake.tositteenPvm(); as n) {
      @if (n.dirty() || n.touched()) {
        @if (onkoVirhe(lomake.tositteenPvm, 'required')) {
          <mat-error>{{ 'kuitit.muokkaa.validation.pvm.required' | translate | async }}</mat-error>
        }
        @if (onkoVirhe(lomake.tositteenPvm, 'matDatepickerParse')) {
          <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerParse' | translate | async }}</mat-error>
        }
        @if (onkoVirhe(lomake.tositteenPvm, 'matDatepickerMax')) {
          <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerMax' | translate | async }}</mat-error>
        }
        @if (onkoVirhe(lomake.tositteenPvm, 'matDatepickerMin')) {
          <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerMin' | translate | async }}</mat-error>
        }
      }
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions style="margin: 30px; margin-top: 12.5px; justify-content: center">
  <button class="secondarybutton" mat-button mat-dialog-close>{{ 'yleiset.peruuta' | translate | async }}</button>
  <button class="primarybutton" mat-button (click)="tallenna()">{{ 'yleiset.tallenna' | translate | async }}</button>
</mat-dialog-actions>
